import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
import { computed } from "vue";
import { ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import storage from "@/utils/storage";
export default {
  __name: 'index',
  props: {
    modelValue: {
      type: String,
      default: ""
    }
  },
  emits: ["uploadSuccess", "update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const url = computed(() => {
      return process.env.VUE_APP_BASE_API + "/user/upload";
    });
    // 设置上传的请求头，包含 token
    const uploadHeaders = computed(() => {
      const token = storage.get("token");
      return {
        Authorization: `Bearer ${token}`
      };
    });
    const emit = __emit;
    const handleAvatarSuccess = response => {
      const {
        data
      } = response;
      if (data.path) {
        emit("uploadSuccess", data.path);
        emit("update:modelValue", data.path);
      }
    };
    const beforeAvatarUpload = rawFile => {
      const allowedFormats = ["image/jpeg", "image/png", "image/gif"];
      if (!allowedFormats.includes(rawFile.type)) {
        ElMessage.error("Avatar picture must be JPG, PNG, or GIF format!");
        return false;
      } else if (rawFile.size / 1024 / 1024 > 2) {
        ElMessage.error("Avatar picture size can not exceed 2MB!");
        return false;
      }
      return true;
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      return _openBlock(), _createBlock(_component_el_upload, {
        class: "avatar-uploader",
        action: url.value,
        headers: uploadHeaders.value,
        "show-file-list": false,
        "on-success": handleAvatarSuccess,
        "before-upload": beforeAvatarUpload
      }, {
        default: _withCtx(() => [__props.modelValue ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.modelValue,
          class: "avatar"
        }, null, 8, _hoisted_1)) : (_openBlock(), _createBlock(_component_el_icon, {
          key: 1,
          class: "avatar-uploader-icon"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Plus))]),
          _: 1
        }))]),
        _: 1
      }, 8, ["action", "headers"]);
    };
  }
};